import type {Input} from './use-upsert-copilot-space-no-chat-state'
import {resourceMetadataToRailsPayload} from '../utils/payload-mapper'
import {useMutation} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type ResourceSizesResult = Record<string, number>

export const useGetCopilotSpaceResourceSizes = () => {
  const {mutateAsync: getCopilotSpaceResourceSizes, ...rest} = useMutation({
    mutationFn: async (input: Input): Promise<ResourceSizesResult> => {
      const body = {
        resources: input.resources?.map(resource => ({
          id: resource.id,
          copilot_chat_attachment_id: resource.copilotChatAttachmentId,
          resource_type: resource.type,
          metadata: resourceMetadataToRailsPayload(resource),
        })),
      }

      const response = await verifiedFetchJSON('/copilot/spaces/resource_sizes', {
        method: 'POST',
        body,
      })
      const data = await response.json()

      if (!response.ok) {
        throw data.errorMessages
      }

      return data as ResourceSizesResult
    },
  })

  return {
    getCopilotSpaceResourceSizes,
    ...rest,
  }
}
